import { Box, Button, IconButton, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { PriceChange, Try } from "@mui/icons-material";
import FlexBetween from "components/FlexBetween";
import axios from "axios";
import { server } from "../../../src/server";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useGetUserQuery } from "state/api";
import { toast } from "react-toastify";

const FormDepense = ({ openPopup, setOpenPopup }) => {
  const userId = useSelector((state) => state.global.userId);
  const { data } = useGetUserQuery(userId);

  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [price, setPrice] = useState(0);
  const [id, setId] = useState("");

  const isNonMobile = useMediaQuery("(min-width:600px)");

  useEffect(() => {
    const res = async (e) => {
      e.preventDefault();
      await axios
        .get(`${server}/depense/get-depenses`)
        .then((res) => {
          console.log(res.data);
          const prestationId = localStorage.setItem("depenseId", res.data._id);
          setId(prestationId);
        })
        .catch((err) => {
          console.log(err);
        });
    };
  }, []);

  const handleFormSubmit = (values) => {
    console.log(values);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!name || !desc || !price) {
        toast.error("Veuillez remplir tous les champs");
      }
      const IdPrestation = await localStorage.getItem("depenseId");
      const res = await axios.put(
        `${server}/depense/add-depense/${IdPrestation}`,
        {
          name,
          desc,
          price,
          userName: data.name,
        }
      );
      console.log(res.data);
      window.location.replace("/depenses");
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Box m="20px">
      <FlexBetween>
        <Header title="AJOUTER UNE DEPENSE" />
        <Button
          color="secondary"
          variant="contained"
          onClick={() => setOpenPopup(false)}
        >
          X
        </Button>
      </FlexBetween>

      <Formik

      // initialValues={initialValues}
      // validationSchema={checkoutSchema}
      >
        {({ values, errors, touched, handleBlur, handleChange }) => (
          <form>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="string"
                label="Nom de la dépense"
                onBlur={handleBlur}
                value={name}
                onChange={(e) => setName(e.target.value)}
                name="Nom"
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="string"
                label="la description"
                onBlur={handleBlur}
                onChange={(e) => setDesc(e.target.value)}
                value={desc}
                name="la description"
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="number"
                label="Somme de la dépense"
                onBlur={handleBlur}
                onChange={(e) => setPrice(e.target.value)}
                value={price}
                name="Somme de la dépense"
                sx={{ gridColumn: "span 4" }}
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                color="secondary"
                variant="contained"
                onClick={handleSubmit}
              >
                Ajouter une depense
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

// const phoneRegExp =
//   /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/;

const checkoutSchema = yup.object().shape({
  Nom: yup.string().required("required"),

  // contact: yup
  //   .string()
  //   .matches(phoneRegExp, "Phone number is not valid")
  //   .required("required"),
  MontantReel: yup.string().required("required"),
  total: yup.string().required("required"),
});
const initialValues = {
  Nom: "",
  interieur: "",
  Couverture: "",
  rabatintercalaire: "",
  total: "",
  MontantReel: "",
};

export default FormDepense;
